<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter01" id="fm1">CIDER BEANS, WILD GREENS, <span class="small">AND</span> DANDELION JELLY</h1>
<p class="center"><img alt="" src="OEBPS/images/9781449400187_t1.jpg"/></p>
<p class="nonindent"><span class="dropcaps2lines"><em>T</em></span>here are many cookbooks about southern cooking, but precious few celebrate the southern Appalachian food that has sustained mountain folk past and present. Now there is <em>Cider Beans, Wild Greens, and Dandelion Jelly</em>, a rare, full-color feast of both traditional and contemporary southern Appalachian dishes, from Mississippi Sin dip, to Pepper Pot Soup, Corn Relish Salad, Whipped Cream Biscuits, Corn Pone Tennessee Style, Southern Butter-Crusted Chicken, Mountain Molasses Stack Cake, Green Tomato Pickles, and much, much more.</p>
<p class="indent">Aller moved to the mountains of Tennessee many years ago, settled in a house on a dirt road up a mountain, and felt like she had come home. Over the years, she’s watched development and other changes come to the region. Feeling a sense of urgency, she set about photographing, writing, and collecting the best recipes southern Appalachia has to offer in an effort to preserve the beauty, culture, traditions, and foodways of the southern mountain people. This book—an Appalachian cookbook like no other—is the result of that labor of love.</p>
<p class="center"><img alt="" src="OEBPS/images/9781449400187_iii.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781449400187_epub_fm1_r1.vue?136cebd4